import React from 'react';
import { Box, Drop, Grommet, Image, Menu, Table, TableRow, TableCell, Stack, TableBody, Spinner } from 'grommet';
const HRNumbers = require('human-readable-numbers');
const pretty = require('pretty-time');

class UnitCounts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modUnits: null,
			data: null,
			players: null,
			unitCounts: null,
			sortMode: {
				mode: "First Produced",
				sortFunc: firstProducedSortFunc,
			},
		};
	}
	componentDidMount() {
		this.loadData();
	}
	componentDidUpdate() {
		if (!this.state.unitCounts) {
			this.makeUnitCounts();
		}
	}
	loadData() {
		if (!this.state.modUnits) {
			fetch("?o=mod_units").then(r => r.json()).then(r => this.setState({modUnits: r}));
		}
		if (!this.state.data) {
			fetch("?o=unit_counts").then(r => r.json()).then(r => this.setState({data: r}));
		}
		if (!this.state.players) {
			fetch("?o=players").then(r => r.json()).then(r => this.setState({players: r}));
		}
	}
	makeUnitCounts() {
		if (!this.state.data || !this.state.players || !this.state.modUnits) {
			return;
		}
		let result = [];
		const data = this.state.data;
		// Iterate over players (i).
		for (let i = 0; i < data.length; i++) {
			if (!data[i]) {
				continue;
			}
			const player = this.state.players[i].player;
			let units = [];
			// Iterate over units per player.
			for (const unitCategoryId in data[i]) {
				const refId = unitCategoryId-1;
				const unitVal = this.state.modUnits[refId];
				const infoVal = data[i][unitCategoryId];
				const info = {
					unit: unitVal,
					info: infoVal,
					component: (
						<Stack
						anchor="top-right"
						key={unitCategoryId}
						>
						<UnitItem
						info={infoVal}
						unit={unitVal}
						categoryId={refId}
						/>
						<Box
						background="#262626"
						pad="xxsmall"
						>
						{data[i][unitCategoryId].produced}
						</Box>
						</Stack>
					),
				};
				units.push(info);
			}
			let playerData = {
				player: this.state.players[i].player,
				units: units,
			};
			result.push(playerData);
		}
		this.setState({unitCounts: result});
	}
	// Menu for sorting options
	orderingItems() {
		const setSortMode = (sortObj) => {
			this.setState({sortMode: sortObj});
		};
		return [
			{
				label: "First Produced",
				onClick: () => setSortMode({
					mode: "First Produced",
					sortFunc: firstProducedSortFunc
				}),
			},
			{
				label: "Total Produced",
				onClick: () => setSortMode({
					mode: "Total Produced",
					sortFunc: totalProducedSortFunc
				}),
			},
			{
				label: "K/D",
				onClick: () => setSortMode({
					mode: "K/D",
					sortFunc: kdSortFunc
				})
			},
			{
				label: "Damage Dealt",
				onClick: () => setSortMode({
					mode: "Damage Dealt",
					sortFunc: damageDealtSortFunc
				}),
			}
		];
	}
	renderUnitCounts() {
		let result = [];
		for (let i = 0; i < this.state.unitCounts.length; i++) {
			const player = this.state.unitCounts[i].player;
			// TODO sorting goes here.
			let units = this.state.unitCounts[i].units.sort(this.state.sortMode.sortFunc);
			const row = (
				<div className="unit-counts" key={player}>
				<h3>{player}</h3>
				<Box direction="row" wrap>
				{this.state.unitCounts[i].units.map(e => e.component)}
				</Box>
				</div>
			);
			result.push(row);
		}
		return result;
	}

	render() {
		if (!this.state.data || !this.state.players || !this.state.modUnits || !this.state.unitCounts) {
			return <Spinner />;
		}
		const unitCounts = this.renderUnitCounts();

		return (
			<Grommet
			background={{dark: true}}
			theme={{
				global: {
					colors: {
						focus: "#0F0",
						text: "#d9d6b3",
						control: "#0F0",
					}
				}
			}}
			>
			<Stack anchor="top-right">
			<Box>
			{unitCounts}
			</Box>
			<h4>
			<Menu label="Order by" items={this.orderingItems()} />
			{this.state.sortMode.mode}
			</h4>
			</Stack>
			</Grommet>
		);
	}
}
class UnitItem extends React.Component {
        state = {};
        ref = React.createRef();
	initToolTip() {
		const unit = this.props.unit;
		const info = this.props.info;
		const cat = this.props.categoryId;
		return (
			<Table>
				<TableBody>
				<TableRow>
				<TableCell>Name</TableCell>
				<TableCell>{unit.name}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>Total Produced</TableCell>
				<TableCell>{info.produced}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>First Produced</TableCell>
				<TableCell>{pretty([0, info.first_produced * 1e6], "s")}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>K/D</TableCell>
				<TableCell>{`${info.kills} / ${info.deaths}`}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>Damage</TableCell>
				<TableCell>
				{HRNumbers.toHumanString(info.damage_dealt) + " / " + HRNumbers.toHumanString(info.damage_received)}</TableCell>
				</TableRow>
				<TableRow>
				<TableCell>Metal</TableCell>
				<TableCell>
				{HRNumbers.toHumanString(info.produced * unit.buildcostmetal)}
				</TableCell>
				</TableRow>
				</TableBody>
			</Table>
		);
	}
        render() {
                const { over } = this.state;
                return (
                        <Box ref={this.ref} margin="xsmall">
                        <Image
                        style={{width: "72px", height: "72px"}}
                        onMouseEnter={() => this.setState({over: true})}
                        onMouseOut={() => this.setState({over: false})}
                        src={this.props.unit.pic}
                        />
                        {this.ref.current && over && (
                                <Drop
                                align={{bottom: "top"}}
                                target={this.ref.current}
                                plain
                                >
                                <Box
                                pad="small"
                                border={{color: "#0F0"}}
                                background="#262626"
                                >
                                {this.initToolTip()}
                                </Box>
                                </Drop>
                        )}
                        </Box>
                );
        }
}
// Sorting functions for Units
const firstProducedSortFunc = (a, b) =>  {
	return a.info.first_produced - b.info.first_produced
};
const totalProducedSortFunc = (a, b) =>  {
	return b.info.produced - a.info.produced
};

const kdSortFunc = (a, b) =>  {
	let kdA = a.info.deaths;
	let kdB = a.info.deaths;
	if (kdA == 0) {
		kdA = a.info.kills;
	} else {
		kdA = a.info.kills / a.info.deaths;
	}
	if (a.info.damage_dealt < 20) {
		kdA = 0;
	}
	if (kdB == 0) {
		kdB = b.info.kills;
	} else {
		kdB = b.info.kills / b.info.deaths;
	}
	if (b.info.damage_dealt < 20) {
		kdB = 0;
	}
	return kdB - kdA
};

const damageDealtSortFunc = (a, b) =>  {
	return b.info.damage_dealt - a.info.damage_dealt
};


import { createRoot } from 'react-dom/client';
const container = document.getElementById('units');
const root = createRoot(container);
root.render(<UnitCounts />);

